<template lang="pug">
  v-row(no-gutters class="pb-4")
    h2(class="headline font-weight-bold pb-6") Мои объявления
    AdvertsListItem(:advertItem="item", v-for="(item, index) in userAdverts", :key="index")
</template>
<script>
export default {
  components: {
    AdvertsListItem: () => import('../../components/Adverts/AdvertsListItem')
  },
  computed: {
    userAdverts() {
      return this.$store.state.userAdverts
    }
  }
}
</script>
